import { useQuery } from '@tanstack/react-query'
import { fetchEnterpriseRegistration } from './api'

export const useEnterpriseRegistration = (enterpriseRegistrationId: string | undefined | null) =>
  useQuery({
    queryKey: ['enterprises-registrations', enterpriseRegistrationId],
    queryFn: async () => {
      if (!enterpriseRegistrationId) {
        throw Error('Cannot fetch card enterprise registration without a enterpriseRegistrationId parameter')
      }

      return fetchEnterpriseRegistration(enterpriseRegistrationId)
    }
  })
